import styled from "styled-components";
import checkedBox from "../../assets/Checkbox.svg";
import cardIcon from "../../assets/card.svg";
import masterCardIcon from "../../assets/mastercard_icon.svg";
import { PiWarningCircleLight } from "react-icons/pi";
import { TiArrowSortedDown } from "react-icons/ti";
import { HiOutlineCheck } from "react-icons/hi";
import logo from "../../assets/Fipay_logo.svg";

export const PaymentInfoWrapper = styled.div`
  flex: 1;
  height: auto;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  box-sizing: border-box;
  overflow-y: auto;
  padding: 0 1rem;

  .flex {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  @media (max-width: 320px) {
    width: 90%;
    align-items: center;
  }
`;

export const PageTitle = styled.span<{ $small?: boolean }>`
  font-size: ${({ $small }) => ($small ? 0.75 : 0.875)}rem;
  font-weight: 400;
  color: #5e5e5e;
`;

export const PaymentMethodsWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.5rem;
`;

export const PaymentMethodWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 200px;
  /* gap: 0.5rem; */
  border: 1px solid #e8eaed;
  padding: 1rem 1.375rem;
  border-radius: 0.625rem;
  cursor: pointer;
  justify-content: space-between;
  /* border: 2px solid blue; */

  .card_icon {
    width: 2rem;
    height: 2rem;
  }

  span {
    font-size: 0.875rem;
    font-weight: 500;
    color: #0e0e0e;
  }
`;

export const AddBankButton = styled.button`
  width: 100%;
  min-width: max-content;
  padding: 0.75rem 1rem;
  border: 1px solid #00a603;
  border-radius: 0.625rem;
  background: transparent;
  color: #00a603;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #f0f7f0;
  }

  &:active {
    background: #e8f3e8;
  }
`;

export const UncheckedCircle = styled.div`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: 1px solid #b9b8b8;
`;

export const CheckedBox = styled.img.attrs({ src: "/assets/Checkbox.svg" })`
  width: 1rem;
  height: 1rem;
`;

export const CardIcon = styled.img.attrs({ src: "/assets/card.svg" })``;

export const MasterCardIcon = styled.img.attrs({ src: "masterCardIcon" })``;

export const InfoIcon = styled(PiWarningCircleLight)`
  width: 1.25rem;
  height: 1.25rem;
  color: #b9b8b8;
`;

export const CardDetailsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1.5rem;
`;

export const CardDetailsLabel = styled.label<{ $half?: boolean }>`
  width: ${({ $half }) => ($half ? 47 : 100)}%;
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 0.5rem;

  .input_icon {
    position: absolute;
    top: 53%;
    right: 1rem;
  }
`;

export const LabelSpan = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #363636;
  position: relative;
`;

export const CardDetailsInput = styled.input<{}>`
  border: 1px solid #e8eaed;
  padding: 0.5rem 1rem;
  border-radius: 0.75rem;
  font-size: 16px;
  font-weight: 400;
  color: #0e0e0e;

  &:focus {
    outline: none;
  }
`;

export const DropdownWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  border: 1px solid #e8eaed;
  padding: 0.5rem 1rem;
  border-radius: 0.75rem;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 400;
  color: #0e0e0e;
  cursor: pointer;
`;

export const SelectedText = styled.span<{ $active?: boolean }>`
  color: #${({ $active }) => ($active ? "0E0E0E" : "B9B8B8")};
`;

export const DropDownList = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 20rem;
  overflow-y: scroll;
  position: absolute;
  top: 120%;
  left: 0;
  width: 100%;
  z-index: 100;
  background-color: #fff;
  border: 1px solid #e8eaed;
`;

export const DropDownListItem = styled.span<{ $defaultValue?: boolean }>`
  padding: 0.5rem 1rem;
  color: #${({ $defaultValue }) => ($defaultValue ? "B9B8B8" : "0E0E0E")};

  &:hover {
    background: #00a603;
    color: #fff;
  }
`;

export const DownArrow = styled(TiArrowSortedDown)<{ $show?: boolean }>`
  transform: rotate(${({ $show }) => ($show ? 180 : 0)}deg);
`;

export const CvvInfo = styled.div.attrs({
  children: "This is the number at the back of your card",
})`
  position: absolute;
  top: -2rem;
  left: 20%;
  right: 20%;
  width: 100%;
  background-color: #fff;
  box-shadow: -3px 5px 15px 0px #b0b0b040;
  border: 1px solid #e8eaed;
  padding: 0.75rem 1rem;
  border-radius: 0.75rem;
  font-size: 0.775rem;
  font-weight: 400;
  color: #0e0e0e;
`;

export const UncheckedBox = styled.div<{ $checked?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  border: 1px solid #${({ $checked }) => ($checked ? "2BD02D" : "CFCFCF")};
  background-color: #${({ $checked }) => ($checked ? "CCF4CD" : "transparent")};
  border-radius: 0.375rem;
`;

export const CheckMark = styled(HiOutlineCheck)`
  color: #00a603;
`;

export const ToggleCheckBoxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
`;

export const PayBtn = styled.button<{
  $active?: boolean;
  backgroundColor?: string;
  color?: string;
  css?: string;
}>`
  padding: 0.5rem 0;
  border-radius: 0.625rem;
  color: ${({ color }) => color || "#fff"};
  background: ${({ backgroundColor }) => backgroundColor || "#00a603"};
  font-size: 1rem;
  font-weight: 500;
  border: 1px solid white;
  opacity: ${({ $active }) => ($active ? 1 : 0.3)};
  ${({ css }) => css || ""}
`;

export const FipayLogo = styled.img.attrs({ src: "/assets/Fipay_logo.svg" })``;

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  height: 1.1875rem;
  font-size: 0.75rem;
  font-weight: 400;
  color: #868686;
  margin: auto;

  img {
    height: 100%;
  }
`;

export const Footer1 = styled.footer`
  display: flex;
  align-items: center;
  height: 1.1875rem;
  font-size: 0.75rem;
  font-weight: 400;
  color: #868686;
  margin: auto;
  margin-top: 1.5rem;

  img {
    height: 100%;
  }
`;

export const VisaTinkOverlay = styled.div`
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 200;
  justify-content: center;
  align-items: center;
  display: flex;
`;
export const VisaTinkIframe = styled.iframe`
  background-color: white;
  max-width: 500px;
  width: 100%;
  height: 700px;
  max-height: 80vh;
  border-radius: 10px;
  border: none;
`;
